import { tracking } from '@iwoca/frontend-tracking-library';
import { connect } from 'react-redux';
// @ts-ignore
import { changeWithKey, getValues } from 'redux-form';

import styles from './CreditCheckConsentModal.module.css';
import { getApplicantState } from '../../helpers/user';
import { AppDispatch, RootState } from '../../reducers';
import { getAmplitudeDefaultEventProperties } from '../../tracking/amplitudeEvents';
import { getLoanDecision as getLoanDecisionAction } from '../LoanDecision/LoanDecision.actions';
import { CLOSE_MODAL } from '../Modals/Modals.actions';
import { Application } from '../PersonalInformation/types/PersonalInformation.types';

type CreditCheckConsentSubmitProps = {
    application: Application;
    formValues: any;
    closeModal: () => void;
    setPrivacyPolicyAgreementDate: (
        indexOfApplicant: number,
        date: string
    ) => void;
    setRolesWithGuarantor: (index: number, roles: string[]) => void;
    getLoanDecision: () => void;
};
const CreditCheckConsentSubmit = ({
    application,
    formValues,
    closeModal,
    setPrivacyPolicyAgreementDate,
    setRolesWithGuarantor,
    getLoanDecision
}: CreditCheckConsentSubmitProps) => {
    const agreeAndProceed = () => {
        const [{ index, roles }] = getApplicantState(
            application.payload,
            formValues
        );
        const date = new Date().toISOString();

        setPrivacyPolicyAgreementDate(index, date);

        tracking.ampli.creditCheckConsentAgreed();
        setRolesWithGuarantor(index, roles);

        closeModal();

        tracking.ampli.personalDetailsSubmitted({
            ...getAmplitudeDefaultEventProperties()
        });

        getLoanDecision();
    };

    return (
        <button className={styles.submit} onClick={agreeAndProceed}>
            Ich stimme zu
        </button>
    );
};

const mapStateToProps = (state: RootState) => {
    const { fetched, form, ui } = state;

    return {
        formValues: getValues(form.sign_up),
        application: fetched.application,
        ui
    };
};

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    closeModal: () => dispatch({ type: CLOSE_MODAL }),
    getLoanDecision: () => dispatch(getLoanDecisionAction()),
    setPrivacyPolicyAgreementDate: (indexOfApplicant: number, date: string) =>
        dispatch(
            changeWithKey(
                'sign_up',
                'personalInformation',
                `people[${indexOfApplicant}].privacy_policy_agreement_date`,
                date
            )
        ),
    setRolesWithGuarantor: (indexOfApplicant: number, roles: string[]) =>
        dispatch(
            changeWithKey(
                'sign_up',
                'personalInformation',
                `people[${indexOfApplicant}].roles`,
                roles
            )
        )
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreditCheckConsentSubmit);
